import { CalendarIcon } from '@calendly/ui/components/icons'
import { DetailsItem as Item } from '@calendly/booking-kit'

import { formatEventTime } from 'services/spot_time'


const getEventTime = (startTime, endTime, timezone, timeNotation) => formatEventTime({
  start_time: startTime,
  end_time: endTime
}, timeNotation, timezone)

const EventTime = ({ timeNotation, timezone, source: { start_time: startTime, end_time: endTime } }) => (
  <Item>
    <div>
      <CalendarIcon size="large" spacingRight={8} data-id="details-item-icon" />
    </div>
    {getEventTime(startTime, endTime, timezone, timeNotation)}
  </Item>
)

export default EventTime
